module.exports = __webpack_public_path__ + "img/Res_Mus_9kl.4bacef1d.jpg";